<template>
  <div class="management-bd">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item v-if="contractTypeData && contractTypeData.length">
          <el-radio-group
            v-model="contractTypeCurren"
            @change="onContractType"
          >
            <el-radio-button
              :label="item.value"
              v-for="(item, index) in contractTypeData"
              :key="index"
            >{{ item.label }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onAddTrialOrder()"
            v-if="userInfo.bizType && (userInfo.bizType.includes('JV')||userInfo.bizType.includes('JV_SC')||userInfo.bizType.includes('HQ') ) && funcView.trial_order_manage_add"
          >
            {{funcView.trial_order_manage_add}}
          </el-button>
        </el-form-item>
        <el-form-item
          v-if="funcView.trial_order_manage_export"
          style="float: right; margin-right: 0 "
        >
          <el-button
            class="table-set"
            style="vertical-align: top;"
            @click="exportTable"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item
          style="float: right"
          :class="{'mr-0': !funcView.trial_order_manage_export}"
        >
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <el-input
            :placeholder="$t('crm_manage.ding_dan_hao')"
            v-model="formSearch.search"
            clearable
            @keyup.enter.native="onPageChange({ page: 1 })"
            style="width: 280px"
          >
            <template slot="append">
              <div @click="onPageChange({ page: 1 })">
                <i class="icon icon-search"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <!-- 租赁方 -->
        <el-form-item :label="$t('crm_manage.yi_fang')">
          <!--
            orgType
            总部:HQ
            售后公司:SC
            代理公司:JV
            服务公司:JV_SC
            大客户:CO
            租赁方:CS
          type
            1-租赁合同+框架协议 2-协议订单 3-试用订单  -->
          <el-input
            v-model="formSearch.customerName"
            :placeholder="$t('Common.com_please_input')"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <!-- 售后公司 -->
        <el-form-item :label="$t('crm_manage.shou_hou_gong_si')">
          <el-input
            v-model="formSearch.afterServiceName"
            :placeholder="$t('Common.com_please_input')"
          ></el-input>
        </el-form-item>
        <!-- 甲方授权代表 -->
        <el-form-item :label="$t('crm_manage.jfsqdb')">

          <el-input
            v-model="formSearch.partAName"
            :placeholder="$t('Common.com_please_input')"
          ></el-input>
        </el-form-item>
        <!-- 创建时间 -->
        <el-form-item :label="$t('crm_manage.chuang_jian_shi_jian')">
          <custom-date-picker
            v-model="formSearch.createTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <!-- 生效时间 -->
        <el-form-item :label="$t('crm_manage.sheng_xiao_shi_jian')">
          <custom-date-picker
            v-model="formSearch.effectiveDate"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_manage.ji_shen_hao')">
          <el-input
            v-model="formSearch.bodyNum"
            :placeholder="$t('Common.com_please_input')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_manage.ye_wu_fu_ze_ren')">
          <el-input
            v-model="formSearch.salesman"
            :placeholder="$t('Common.com_please_input')"
          ></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="tb1"
        height="100%"
        type="radio"
        v-loading="isLoading"
        :data="contractList"
        :column="tableColumn"
        :index="true"
        :filterArr="filterArr"
        :slots="['contractNo', 'productDetail', 'locationNameAndSiteName', 'action']"
        @filter="filterChange"
        @sort="sortChange"
      >
        <template v-slot:locationNameAndSiteName="scope">
          {{getLocationNameAndSiteName(scope.row) || '-'}}
        </template>
        <template v-slot:contractNo="scope">
          <div
            v-if="funcView.trial_order_manage_watch"
            class="cell-link"
            @click="jump('/contractdetail', { contractId: scope.row.bizId, contractClass: scope.row.orderType, parentPath: $route.path, billType: 15 })"
          >
            {{ scope.row.contractNo }}
          </div>
          <span v-else>{{ scope.row.contractNo }}</span>
        </template>
        <template v-slot:productDetail="scope">
          <el-popover
            placement="bottom"
            width="340"
            trigger="hover"
            v-if="scope.row.goodsCountList"
          >
            <el-table :data="scope.row.goodsCountList">
              <el-table-column
                width="100"
                property="productCode"
                :label="$t('crm_manage.xing_hao')"
              ></el-table-column>
              <el-table-column
                width="70"
                property="deviceBizType"
                :label="$t('crm_manage.she_bei_lei_xing')"
              ></el-table-column>
              <el-table-column
                width="70"
                property="bookingNum"
                :label="$t('crm_manage.shu_liang')"
              ></el-table-column>
              <el-table-column
                width="70"
                property="rentalTerm"
                :label="$t('crm_manage.tian_shu')"
              ></el-table-column>
            </el-table>
            <el-button
              slot="reference"
              type="text"
            >{{ $t('crm_manage.cksbxq') }}</el-button>
          </el-popover>
          <el-button
            v-else
            type="text"
          >{{ $t('crm_manage.cksbxq') }}</el-button>
        </template>
        <!-- overview -->
        <template
          slot="action"
          slot-scope="scope"
          v-if="scope.row.contractHandle"
        >
          <!--
              添加试用订单 trial_order_manage_add
              列表 trial_order_manage_list
              订单详情 trial_order_manage_watch
              编辑 trial_order_manage_edit
              删除 trial_order_manage_delete
              撤销 trial_order_manage_cencel
              作废 trial_order_manage_revoke
              拷贝 trial_order_manage_copy
              提交 trial_order_manage_submit
            -->
          <span></span>
          <el-button
            v-if="funcView.trial_order_manage_edit && scope.row.contractHandle.edit"
            type="text"
            size="mini"
            @click="onEditTrialOrder(scope.row)"
          >{{funcView.trial_order_manage_edit}}</el-button>

          <!-- 更多操作 -->
          <el-dropdown
            style="vertical-align: top"
            v-show="scope.row.showMoreAction"
          >
            <el-button
              type="text"
              size="mini"
            >
              <span>{{ $t('Common.com_more_action') }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                @click.native="deleteContract(scope.row)"
                v-if="funcView.trial_order_manage_delete && scope.row.contractHandle.delete"
              >{{ funcView.trial_order_manage_delete }}{{ showMore(scope.row) }}</el-dropdown-item>
              <el-dropdown-item
                @click.native="submitContract(scope.row)"
                v-if="funcView.trial_order_manage_submit && scope.row.contractHandle.submit"
              >{{ funcView.trial_order_manage_submit }}{{ showMore(scope.row) }}</el-dropdown-item>
              <el-dropdown-item
                @click.native="cancelContract('trail_order', scope.row.bizId)"
                v-if="funcView.trial_order_manage_cencel && scope.row.contractHandle.cancel"
              >{{ funcView.trial_order_manage_cencel }}{{ showMore(scope.row) }}</el-dropdown-item>
              <el-dropdown-item
                @click.native="onEditSalesman(scope.row)"
                v-if="funcView.trial_order_changeSalesman && scope.row.contractHandle.changeSalesman"
              >
                {{ funcView.trial_order_changeSalesman }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <el-dropdown-item
                @click.native="revokeContract('trail_order', scope.row.bizId)"
                v-if="funcView.trial_order_manage_revoke && scope.row.contractHandle.revoke"
              >{{ funcView.trial_order_manage_revoke }}{{ showMore(scope.row) }}</el-dropdown-item>
              <el-dropdown-item
                @click.native="onCopyTrialOrder(scope.row)"
                v-if="funcView.trial_order_manage_copy && scope.row.contractHandle.copy"
              >{{ funcView.trial_order_manage_copy }}{{ showMore(scope.row) }}</el-dropdown-item>
              <el-dropdown-item
                @click.native="onCloseTrialOrder(scope.row)"
                v-if="funcView.trial_order_manage_close && scope.row.contractHandle.close && scope.row.toRental"
              >{{ funcView.trial_order_manage_close }}{{ showMore(scope.row) }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- 发送电子合同 -->
    <contract-confirm-dialog
      v-if="dialogVisible3"
      :data="dialogData3"
      :model="dialogModel3"
      @close="dialogVisible3 = false"
      @success="sendContract"
    ></contract-confirm-dialog>
    <!-- 租赁确认单 -->
    <!-- <contract-lease-confirmed v-if="dialogVisible5" :model="dialogModel5" @close="dialogVisible5 = false"></contract-lease-confirmed> -->
    <!-- 打印租赁确认单第一步 选择设备 -->
    <contract-deviceSelect-dialog
      v-if="dialogVisible5"
      :model="dialogModel5"
      @close="dialogVisible5 = false"
    ></contract-deviceSelect-dialog>
    <!-- 修改业务负责人 -->
    <contract-salesman-dialog
      v-if="dialogVisible7"
      :model="dialogModel7"
      @close="dialogVisible7 = false"
    ></contract-salesman-dialog>
    <!-- 关闭订单 -->
    <order-close-dialog
      v-if="dialogVisible8"
      :model="dialogModel8"
      @close="dialogVisible8 = false"
    ></order-close-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import contractRule from '@/utils/contractRule.js';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
// import contractLeaseConfirmed from '@/pages/crm/components/leaseConfirmed.vue';
import contractDeviceSelectDialog from '@/pages/crm/components/contract_deviceSelect_dialog.vue';
import contractSalesmanDialog from '@/pages/crm/contractComponents/contract_salesman_dialog.vue';
import contractConfirmDialog from '@/pages/crm/contractComponents/contract_confirmSend_dialog.vue';
import moment from 'moment';
import orderCloseDialog from '@/pages/crm/contractComponents/order_close_dialog.vue';

export default {
  name: 'trialOrderManagement',
  props: {
    contractTypeData: [Array], // 合同类型
    value: [String, Number],
    contractType: [String, Number]
  },
  components: {
    contractConfirmDialog,
    // contractLeaseConfirmed,
    // 操作
    contractDeviceSelectDialog,
    contractSalesmanDialog,
    orderCloseDialog
  },
  mixins: [resetFormSearchMixins],
  data() {
    return {
      tableCode: 'try_order_list',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        contractType: ['10'],
        contractState: '',
        customerName: '',
        afterServiceName: '',
        partAName: '',
        createTime: '',
        createStartDate: '', // 创建开始时间
        createEndDate: '', // 创建开始时间
        effectiveDate: '',
        effectiveStartDate: '', // 生效开始时间
        effectiveEndDate: '', // 生效开始时间
        locationName: '',
        bodyNum: '',
        salesman: '',
      },
      // 更多筛选
      searchFilters: false,
      dataTimes: [],
      totalRows: null,
      isLoading: false,
      contractList: [],
      // 合同类型

      // 审批
      dialogVisible1: false,
      dialogModel1: {},
      dialogData1: {},
      // 退回
      dialogVisible2: false,
      dialogModel2: {},
      dialogData2: {},
      // 发送电子合同 确认签署
      dialogVisible3: false,
      dialogModel3: {},
      dialogData3: {},
      //  租赁确认单
      dialogVisible5: false,
      dialogModel5: {},
      //  合同操作
      dialogVisible6: false,
      dialogModel6: {},
      //  修改业务负责人
      dialogVisible7: false,
      dialogModel7: {},
      //  关闭订单
      dialogVisible8: false,
      dialogModel8: {},
      // 用户身份
      // userInfo: {},
      // 操作
      visibleSet: '',
      dialogSetData: {},
      link: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    filterArr() {
      const arr = [];
      return arr;
    },
    contractTypeCurren: {
      get() {
        // 回调函数 当需要读取当前属性值是执行，根据相关数据计算并返回当前属性的值
        return this.contractType;
      },
      set(val) {
        // 监视当前属性值的变化，当属性值发生变化时执行，更新相关的属性数据
        this.$emit('input', val);
      }
    }
  },
  mounted() {
    this.formSearch.createTime = [this.$momentWorld(moment().startOf('month')), this.$momentWorld(moment().endOf('day'))];
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getContract();
    this.getTableColumn();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    // this.userInfo = this.$store.state.userInfo;
  },
  activated() {
    // this.userInfo = this.$store.state.userInfo;
    // this.getContract();
  },
  methods: {
    onAddTrialOrder() {
      this.clearTagByKeep('tryManagement_item');
      this.jump('/redirect/contract/trialOrder/add', { parentPath: '/contract/trialOrder' });
    },
    onEditTrialOrder(row) {
      this.clearTagByKeep('tryManagement_item');
      this.jump('/redirect/contract/trialOrder/edit', { contractId: row.orderId, parentPath: '/contract/trialOrder' });
    },
    onCopyTrialOrder(row) {
      this.clearTagByKeep('tryManagement_item');
      this.jump('/redirect/contract/trialOrder/copy', { contractId: row.orderId, copy: true, parentPath: '/contract/trialOrder' });
    },
    // 更多操作
    showMore: function (row) {
      row.showMoreAction = true;
      return '';
    },
    getContract: function () {
      this.isLoading = true;
      this.formSearch.createStartDate = this.formSearch.createTime && this.formSearch.createTime[0] ? this.formSearch.createTime[0] : undefined;
      this.formSearch.createEndDate = this.formSearch.createTime && this.formSearch.createTime[1] ? this.formSearch.createTime[1] : undefined;
      this.formSearch.effectiveStartDate = this.formSearch.effectiveDate && this.formSearch.effectiveDate[0] ? this.formSearch.effectiveDate[0] : undefined;
      this.formSearch.effectiveEndDate = this.formSearch.effectiveDate && this.formSearch.effectiveDate[1] ? this.formSearch.effectiveDate[1] : undefined;
      this.formSearch.loadRes = this.$route.path;
      this.$getJSON(apis.trialOrderPage, this.formSearch).then((res) => {
        if (res.code === 0) {
          this.isLoading = false;
          this.totalRows = res.data.total;

          const data = res.data.list || [];
          data.forEach((item) => {
            this.contractControl(item);
          });
          this.contractList = data;
        }
      });
    },
    // 合同变更控制
    contractControl: function (detail) {
      // (1)合同类型： 10-试用合同，20-租赁合同，21-续租合同，30-框架合同，41-E类购，42-新机购，43-租转售，50-租售订单
      // (2)合同业务状态: 1-草稿，6-审批中，10-审批通过，20-已生效，21-总部已发货，22-售后公司已收货，23-售后公司已发货，24-租赁方已收货，26-租赁方已发货，
      // 31-部分试用，32-已试用，35-部分启租，36-已启租，66-部分违约，70-已终止，80-已到期，90-审批拒绝，100-已作废
      // (3)合同角色: 甲方(JV)partyAId、售后公司(SC)afterServiceId、乙方(CS)customerId、总部(HQ)(独立于合同角色外，为创建合同账号的总部)
      // (4)合同变更: 变更设备 device、终止合同 stop_contract、变更启租日期 rent_date、变更售后公司 after_service
      // 暂停使用 stop_use、终止设备租赁 stop_rent、期末续机 continue_rent、变更支付周期 payment_cycle
      // (5)操作类型（'起租'在详情设备tab里，'审批,作废'合同列表和合同详情都要，其前面都在合同列表里，其后面都在合同详情里）: 终止试用 stop_test、试用转租赁 test_to_rent、编辑 edit、删除 delete、提交 submit、打印合同 print、查看 watch、启租（设备里面） start、撤销 cancel
      // 打印确认单 printConfirm、修改负责人 changeHead、审批 verify、作废 revoke、总部发货 factorySend、售后发货 aftersaleSend、乙方收货 partybReceive，firstPay 修改首付款
      const contractRoles = this.getCurContractRole(detail);
      // this.getDictionary('crm_order_handle_control', (dic) => {
      //   const contractHandle = this.contractAuthControl(dic.crm_order_handle_control, detail.orderType, detail.orderState, contractRoles);
      //   this.$set(detail, 'contractHandle', contractHandle);
      // });
      const contractHandle = this.contractAuthControl(contractRule.handleRules, detail.orderType, detail.orderBizState, contractRoles);
      this.$set(detail, 'contractHandle', contractHandle);
    },
    // 合同控制（操作/变更）
    contractAuthControl: function (rules, contractType, contractState, contractRoles) {
      const stateList = this.listFindOneChildren(rules, contractType);
      const actionList = this.listFindOneChildren(stateList, contractState);
      const result = actionList.filter(t => contractRoles.find(f => t.roleCode && t.roleCode.includes(f)));
      const data = {};
      result.forEach((item) => {
        data[item.value] = true;
      });
      return data;
    },
    // 获取当前账号合同担任角色
    getCurContractRole: function (detail) {
      const userInfo = this.$store.state.userInfo;
      const rootOrgId = userInfo ? userInfo.rootOrgId : ''; // 当前账户组织
      const contractRoles = []; // 当前用户在合同中担任角色列表
      // 是否是总部
      if (userInfo && userInfo.bizType === 'HQ') {
        contractRoles.push('HQ');
      }
      if (`${rootOrgId}` === `${detail.partyAId}`) {
        contractRoles.push('JV');
      }
      if (`${rootOrgId}` === `${detail.afterServiceId}`) {
        contractRoles.push('SC');
      }
      if (`${rootOrgId}` === `${detail.customerId}`) {
        contractRoles.push('CS');
      }
      return contractRoles;
    },

    // 字典处理函数
    listFindOneChildren: function (list, value) {
      let result = [];
      const row = list.find(t => `${t.value}` === `${value}`);
      if (row) {
        result = row.children || [];
      }
      return result;
    },
    // 合同操作
    onContractHandle: function ({ showType, row }) {
      // 期末续租
      if (showType === 'date_end_continue') {
        this.jump('/contract/management/leasecontinueadd', {
          lastOrderId: row.bizId,
          oldContractId: this.contractId,
          oldContractClass: this.contractClass,
        });
        return;
      }
      // 试用转租赁
      if (showType === 'test_to_rent') {
        this.jump('/contract/management/leaserentadd', {
          lastOrderId: row.bizId,
          oldContractId: this.contractId,
          oldContractClass: this.contractClass,
        });
        return;
      }
      if (showType === 'approval') {
        this.dialogModel6.title = this.$t('crm_manage.shen_pi_he_tong');
      }
      if (showType === 'factorySend') {
        this.dialogModel6.title = this.$t('crm_manage.zong_bu_fa_huo');
      }
      if (showType === 'aftersaleSend') {
        this.dialogModel6.title = this.$t('crm_manage.shgsfh');
      }
      if (showType === 'partybReceive') {
        this.dialogModel6.title = this.$t('crm_manage.zu_lin_fang_shou_huo');
      }
      if (showType === 'firstpay') {
        this.dialogModel6.title = this.$t('crm_manage.bgsfk');
      }
      this.dialogModel6.data = row;
      this.dialogVisible6 = showType;
    },
    // 操作按钮要传row
    beforeHandleCommand(item, row) {
      return {
        showType: item,
        row: row,
      };
    },
    // 合同操作弹窗
    onSetDialog: function (type, row) {
      this.dialogSetData = row;
      this.visibleSet = type;
    },
    // 合同类型
    contractTypeChange: function (num) {
      this.formSearch.contractType = num;
      this.onPageChange({ page: 1 });
    },
    deleteContract: function (row) {
      this.$confirm(this.$t('crm_manage.nqdyscdqhtm'), this.$t('Common.com_reminder'), {
        confirmButtonText: this.$t('Common.com_confirm'),
        cancelButtonText: this.$t('Common.com_cancel'),
        closeOnClickModal: false,
        type: 'warning',
      })
        .then(() => {
          this.$postJSON(apis.contractDelete, {
            bizClass: row.bizClass,
            bizId: row.bizId,
          }).then(() => {
            this.$message({
              message: this.$t('crm_manage.schtcg'),
              type: 'success',
            });
            this.getContract();
          });
        })
        .catch(() => { });
    },
    submitContract: function (row) {
      this.$confirm(this.$t('crm_manage.nqdytjhtm'), this.$t('Common.com_reminder'), {
        confirmButtonText: this.$t('Common.com_confirm'),
        cancelButtonText: this.$t('Common.com_cancel'),
        closeOnClickModal: false,
        type: 'warning',
      })
        .then(() => {
          this.$postJSON(apis.contractSubmit, {
            bizClass: row.bizClass,
            bizId: row.bizId,
          }).then(() => {
            this.$message({
              message: this.$t('crm_manage.tjhtcg'),
              type: 'success',
            });
            this.getContract();
          });
        })
        .catch(() => { });
    },
    // 撤销
    cancelContract: function (type, id) {
      this.$confirm(this.$t('crm_manage.nqdycxdqhtm'), this.$t('Common.com_reminder'), {
        confirmButtonText: this.$t('Common.com_confirm'),
        cancelButtonText: this.$t('Common.com_cancel'),
        closeOnClickModal: false,
        type: 'warning',
      })
        .then(() => {
          this.$postJSON(`${apis.apsApproveApprovalApproveRevoke}/${type}/${id}`).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.getContract();
            }
          });
        })
        .catch(() => { });
    },
    // 撤销
    revokeContract: function (type, id) {
      this.$confirm(this.$t('crm_manage.nqdyzfdqhtm'), this.$t('Common.com_reminder'), {
        confirmButtonText: this.$t('Common.com_confirm'),
        cancelButtonText: this.$t('Common.com_cancel'),
        closeOnClickModal: false,
        type: 'warning',
      })
        .then(() => {
          this.$postJSON(`${apis.apsApproveApprovalCancel}/${type}/${id}`).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.getContract();
            }
          });
        })
        .catch(() => { });
    },
    modifyLeaderContract: function ({ bizClass, bizId, projectContactName, projectContactPhone }) {
      this.dialogVisible1 = true;
      this.dialogModel1.title = this.$t('crm_manage.xgxmfzr');
      // 项目负责人
      this.dialogModel1.data = {
        bizClass,
        bizId,
        projectContactName,
        projectContactPhone,
      };
    },
    returnContract: function (contractId) {
      this.dialogVisible2 = true;
      this.dialogModel2.title = this.$t('crm_manage.tui_hui_he_tong');
      this.dialogData2.contractId = contractId;
    },
    // 关闭订单
    onCloseTrialOrder(row) {
      this.dialogVisible8 = true;
      this.dialogModel8.bizId = row.bizId;
      this.dialogModel8.contractNo = row.contractNo;
    },
    // 修改业务负责人
    onEditSalesman(row) {
      this.dialogVisible7 = true;
      this.dialogModel7.title = this.$t('crm_manage.bjywfzr');
      this.dialogModel7.bizId = row.bizId;
      this.dialogModel7.bizClass = row.bizClass;
      this.dialogModel7.partyAId = row.partyAId;
    },
    // 下载租赁确认单
    downloadConfirmed(row) {
      this.dialogVisible5 = true;
      this.dialogModel5.title = this.$t('crm_manage.xuan_ze_she_bei');
      this.dialogModel5.bizId = row.bizId;
      this.dialogModel5.bizClass = row.bizClass;
      this.dialogModel5.type = 'trial';
    },
    // 更多筛选显示
    searchFiltersShow: function () {
      this.searchFilters = !this.searchFilters;
    },
    onContractType(val) {
      this.$emit('input', val);
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getContract();
    },
    // 切换每页数量
    onSizeChange: function (size) {
      this.formSearch.pageSize = size;
      this.getContract();
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.trialOrderExport, this.formSearch).then(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.management-bd {
  padding-left: 16px;
  display: flex;
  height: 100%;
  flex-direction: column;
}
</style>
